import React, { useState } from "react";
import { motion } from "framer-motion";
import "./ManufacturingExcellence.css";

const products = [
  {
    id: 1,
    img: "/WebPictures/infra4.jpg",
    series: "equipment series",
    title: "Advanced Equipment",
    desc: "DEK Horizon Solder Paste Printer for precision paste application. Yamaha YS 24 High-Speed Mounter for rapid component placement. Philips TopazX and YV-100X SMD Mounters for versatile assembly. Mirtec AOI (USA) with high-resolution inspection for PCBs up to 500×400 mm.",
  },
  {
    id: 2,
    img: "/WebPictures/infra1.jpg",
    series: "facility series",
    title: "Our Facility",
    desc: "10,000 sq ft facility across 3 floors in Gurgaon and Bhiwadi, India. ESD-compliant environment for safe PCBA and mechanical assembly. 150,000 CPH production capacity for high-volume manufacturing. Integrated processes for seamless production workflows.",
  },
  {
    id: 3,
    img: "/WebPictures/infra7.jpg",
    series: "process series",
    title: "Robust Processes",
    desc: "Lean manufacturing and 5S methodologies for operational efficiency. CRC coating, masking, and adhesive application tailored to customer needs. Comprehensive PCB stencil design and fabrication. Process engineering, QA, testing, and debugging for reliable PCBAs.",
  },
  {
    id: 4,
    img: "/WebPictures/infra2.jpg",
    series: "capacity series",
    title: "Production Capacity",
    desc: "With a capacity of 150,000 CPH, our advanced equipment ensures high-speed, high-volume production to meet your deadlines without compromising quality. Heller 1808 Reflow Oven (8+2 zones) for reliable soldering. Handles 0201, 0402 SMD chips, fine-pitch ICs (QFN, BGA).",
  },
];

const fadeUp = {
  hidden:  { opacity: 0, y: -22 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};
const ornAnim = {
  hidden:  { opacity: 0, scaleX: 0 },
  visible: { opacity: 1, scaleX: 1, transition: { duration: 0.7, delay: 0.35, ease: "easeOut" } },
};

const ManufacturingExcellence = () => {
  
  const [expanded, setExpanded] = useState(null);
  const toggleExpand = (id) => setExpanded(expanded === id ? null : id);

  return (
    <section className="mex-section">
      <div className="mex-container">

        {/* ── Heading ── */}
        <motion.div
          className="mex-heading-wrap"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
        >
          <motion.span className="mex-heading-serif" variants={fadeUp}>
          
          </motion.span>
          <motion.h2
            className="mex-heading"
            variants={fadeUp}
            transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
          >
            Our Manufacturing <span>Excellence</span>
          </motion.h2>
          <motion.div className="mex-heading-ornament" variants={ornAnim}>
            <div className="mex-orn-line-l" />
            <div className="mex-orn-gem" />
            <div className="mex-orn-line-r" />
          </motion.div>
        </motion.div>

        {/* ── Cards Grid ── */}
        <div className="mex-grid">
          {products.map((item, i) => (
            <motion.div
              key={item.id}
              className="mex-card"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.12 }}
              transition={{ duration: 0.5, delay: i * 0.09, ease: "easeOut" }}
            >
              {/* Image zone */}
              <div className="mex-card-top">
                <img src={item.img} alt={item.title} className="mex-img" />
                {/* Hover overlay */}
                <div className="mex-overlay">
                  <p className="mex-overlay-text">{item.desc}</p>
                </div>
              </div>

              {/* Text zone */}
              <div className="mex-card-bottom">
                <span className="mex-series">{item.series}</span>
                <h3 className="mex-title">{item.title}</h3>

                {/* Mobile expandable desc */}
                <p className={`mex-desc${expanded === item.id ? " mex-desc--open" : ""}`}>
                  {item.desc}
                </p>

                {/* Mobile toggle only */}
                <div className="mex-cta mobile-only">
                  <button
                    className="mex-toggle"
                    onClick={() => toggleExpand(item.id)}
                  >
                    {expanded === item.id ? "Hide" : "Read More"}
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ManufacturingExcellence;